/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ui.segment.footer[_ngcontent-%COMP%]{margin-top:5em;padding:3em 0;border-radius:0;background:#191b1f}.ui.segment.footer[_ngcontent-%COMP%]   .grid[_ngcontent-%COMP%]{margin:0;display:flex;justify-content:space-around}.ui.segment.footer[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:rgba(255,255,255,.4)}.white[_ngcontent-%COMP%]{color:#fff}"];
export { styles as styles };
